import './styles.scss';

import Parser from '@helpers/parser'

export default function PlansSidebar({ community }) {


    if (!community?.plans?.length) return null;

    return (
        <div className="plans-sidebar">
            <h3 className="plans-sidebar-title mb-2 mt-1">Planos de membros</h3>

            {community.plans.map((plan) => (
                <PlanBox key={plan.id} plan={plan} community={community} />
            ))}
        </div>
    )
}


function PlanBox({ plan, community }) {
    const priceValue = Parser.price.brl((plan.installments_list?.[plan.installments - 1] / plan.installments) || plan.price);
    const interval = Parser.interval.noun(plan.interval).toLowerCase();

    function handleOpenCheckout() {
        window.open(`https://pay.ginastee.com/${community.checkout}?plan=${plan.id}`, '_blank');
    }

    return (
        <div className='ticket-wrap' onClick={handleOpenCheckout}>
            <div className='ticket ticket-top bsf-9'>
                <div className='ticket-header'>

                    {community?.banner
                        ? <img src={community.banner} alt={plan.name} className='banner' />
                        : <div className='banner' />}

                    <div className='title'>
                        <h4 className="csf-2">{plan.label}</h4>
                    </div>
                </div>

                <div className='ticket-price'>
                    {
                        plan.installments > 1 && <div><span className='installments csf-4'>{plan.installments}x de</span><br /></div>
                    }
                    <div className='price-value'>
                        <h3 className="bold">R${priceValue}</h3>
                        {
                            plan.interval !== 'lifetime' && <span style={{ transform: 'translateX(-3px)' }}>por {interval}</span>
                        }
                    </div>

                    {
                        plan.interval === 'lifetime' && <span style={{ transform: 'translateX(-3px)' }}>para ter acesso vitalício</span>
                    }

                </div>

                <div className='ticket-barcode'></div>
            </div>

            <div className='ticket ticket-bottom bsf-1'>
                <span className='ticket-bottom-text bold csf-8'>Adquirir {plan.label}</span>
            </div>
        </div >
    )
}